import { RootState } from 'surface/xstore/types'
import { Module } from 'vuex'

enum ImagePickerSources {
  WebBrowser,
  FileBrowser,
  LinkInput,
  PhotoBooth,
  DrawingCanvas,
}

interface ImagePickerState {
  xImagePicker: boolean
  activeSource: ImagePickerSources | null
  initialSearchQuery?: string
  disallowGifSearch: boolean
  onPickAction?: string
  pendingFile: File | null
}

interface ShowImagePickerSources {
  onPickAction: string
  initialSearchQuery?: string
  disallowGifSearch?: boolean
}

const defaultState = (): ImagePickerState => ({
  xImagePicker: false,
  activeSource: null,
  initialSearchQuery: undefined,
  disallowGifSearch: false,
  onPickAction: undefined,
  pendingFile: null,
})

const ImagePickerModule: Module<ImagePickerState, RootState> = {
  namespaced: true,
  state: defaultState(),
  getters: {
    xImagePickerSources: (state): boolean => state.xImagePicker,
    activeSource: (state): ImagePickerSources | null => state.activeSource,
    pendingFile: (state): File | null => state.pendingFile,
    initialSearchQuery: (state): string | undefined => state.initialSearchQuery,
    disallowGifSearch: (state): boolean => state.disallowGifSearch,
  },
  mutations: {
    SHOW_IMAGE_PICKER_SOURCES(
      state,
      { onPickAction, initialSearchQuery, disallowGifSearch }: ShowImagePickerSources,
    ): void {
      state.xImagePicker = true
      state.onPickAction = onPickAction
      state.initialSearchQuery = initialSearchQuery
      state.disallowGifSearch = !!disallowGifSearch
    },
    CHANGE_ACTIVE_SOURCE(state, source: ImagePickerSources): void {
      state.activeSource = source
    },
    CLEAR_ACTIVE_SOURCE(state): void {
      state.activeSource = null
    },
    HIDE_IMAGE_PICKER_SOURCES(state): void {
      Object.assign(state, defaultState())
    },
    START_UPLOAD(state, file: File): void {
      state.pendingFile = file
    },
    STOP_UPLOAD(state): void {
      state.pendingFile = null
    },
  },
  actions: {
    showImagePickerSources({ commit }, payload: ShowImagePickerSources): void {
      commit('SHOW_IMAGE_PICKER_SOURCES', payload)
    },
    changeActiveSource({ commit }, source: ImagePickerSources): void {
      commit('CHANGE_ACTIVE_SOURCE', source)
    },
    clearActiveSource({ commit }): void {
      commit('CLEAR_ACTIVE_SOURCE')
    },
    pickImageUrl({ commit, dispatch, state }, url): void {
      state.onPickAction && dispatch(state.onPickAction, { url }, { root: true })
    },
    hideImagePickerSources({ commit }): void {
      commit('HIDE_IMAGE_PICKER_SOURCES')
    },
    startUpload({ commit }, file: File): void {
      commit('START_UPLOAD', file)
    },
    stopUpload({ commit }): void {
      commit('STOP_UPLOAD')
    },
  },
}

export default ImagePickerModule
export { ImagePickerState, ImagePickerSources }
